module.exports = __webpack_public_path__ + "img/pic_3.21c958a0.png";